import {FiPlus} from "react-icons/fi";

import {RequiredDateRange} from "@/components/datetime/utils.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {StandardDateRange} from "@/lib/queries/reports.ts";
import {UserDateRangePicker} from "@/pages/alerting/components/list/alertsControlBar/UserDateRangePicker.tsx";
import {IncidentCreateAction} from "@/pages/incidents/actions/IncidentCreateAction.tsx";

interface IncidentsActionBarProps {
  visibleRange: RequiredDateRange;
  fixedRange?: StandardDateRange;
  onVisibleRangeChange: (visibleRange: RequiredDateRange | null, fixedRange?: StandardDateRange | null) => void;
}

export const IncidentsActionBar = ({visibleRange, fixedRange, onVisibleRangeChange}: IncidentsActionBarProps) => {
  return (
    <div className="d-flex gap-3">
      <UserDateRangePicker
        range={visibleRange}
        fixedRange={fixedRange}
        onChange={onVisibleRangeChange}
        size={"large"}
        maxRange={730}
      />
      <IncidentCreateAction size="large">
        <Icon icon={FiPlus} />
        Create Incident
      </IncidentCreateAction>
    </div>
  );
};
